import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.is-extensible";
import * as React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/core";

var Wrapper = function Wrapper(_ref) {
  var children = _ref.children;
  return ___EmotionJSX(React.Fragment, null, children);
};

export default Wrapper;

if (typeof Wrapper !== 'undefined' && Wrapper && Wrapper === Object(Wrapper) && Object.isExtensible(Wrapper) && !Wrapper.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Wrapper, '__filemeta', {
    configurable: true,
    value: {
      name: "Wrapper",
      filename: "node_modules/gatsby-theme-docz/src/wrapper.js"
    }
  });
}